/* eslint-disable security/detect-object-injection */
/* eslint-disable react/jsx-key */
/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import MsDyn365, { IImageData, IImageSettings, Image } from '@msdyn365-commerce/core';
import { ArrayExtensions, generateImageUrl } from '@msdyn365-commerce-modules/retail-actions';
import {
    getPayloadObject,
    getTelemetryAttributes,
    getTelemetryObject,
    IPayLoad,
    ITelemetryContent,
    Module,
    Node,
    onTelemetryClick
} from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';
import * as React from 'react';

import { INavigationMenuViewProps } from './moe-kwr-navigation-menu';
import { IMenuItemData } from './moe-kwr-navigation-menu.data';

import { CategoryModal } from '../../components/categorymodal.component';
import { EnagageModal } from '../../components/engagemodal.component';
import { CurriculaModal } from '../../components/curriculamodal.component';
// import { Logo } from './components/logo';
import { getUrlSync, getAsset } from '@msdyn365-commerce/core';
import { getCategoryDescriptionAsync } from '../../actions/extensions/DataActionExtension.g';
import { searchByCriteriaAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';
import { ProductSearchCriteria } from '@msdyn365-commerce/retail-proxy';
// import { getToggleLang } from '../../utilities/language-change';
import { IKwrHomePageLanguageAttributes } from '../moe-kwr-homepage/moe-kwr-homepage.view';
import {
    ENGLISH_LANG,
    ENGLISH_LANG_CODE,
    ENGLISH_TOGGLE_PREFIX,
    MAORI_LANG,
    MAORI_LANG_CODE,
    MAORI_TOGGLE_PREFIX
} from '../../utilities/constants';

interface INavigationState {
    parentMenu?: number;
    activeMenu?: number;
    categoryImage?: IImageData[] | null;
    mobileViewLabelText?: string;
    categoryImageAltText: string;
    categoryMemuIsActive: boolean;
    engageMenuIsActive: boolean;
    curriculaMenuIsActive: boolean;
    categoryDescription: string;
    curatedProduct: any[];
    isMenuOpen: boolean;
}

/**
 *
 * NavigationMenuView component.
 * @extends {React.PureComponent<INavigationMenuViewProps>}
 */
export class NavigationMenuView extends React.PureComponent<INavigationMenuViewProps, INavigationState> {
    private static isBackTrack: boolean = false;

    private currentLevel: number = 0;

    private readonly menuNode: React.RefObject<HTMLUListElement>;

    private readonly menuItemRef: React.RefObject<HTMLElement>;

    private readonly telemetryContent: ITelemetryContent;

    private readonly payLoad: IPayLoad;

    constructor(props: INavigationMenuViewProps) {
        super(props);
        this.menuNode = React.createRef();
        this.menuItemRef = React.createRef();
        this.state = {
            activeMenu: undefined,
            mobileViewLabelText: '',
            parentMenu: undefined,
            categoryImageAltText: '',
            categoryMemuIsActive: false,
            engageMenuIsActive: false,
            curriculaMenuIsActive: false,
            categoryDescription: '',
            curatedProduct: [],
            isMenuOpen: false
        };
        this._closeSubmenu = this._closeSubmenu.bind(this);
        this.telemetryContent = getTelemetryObject(
            this.props.context.request.telemetryPageName!,
            this.props.friendlyName,
            this.props.telemetry
        );
        this.payLoad = getPayloadObject('click', this.telemetryContent, '', '');
    }

    public componentDidMount(): void {
        if (MsDyn365.isBrowser) {
            document.body.addEventListener('mousedown', this._handleClickOutside);
            document.body.addEventListener('focusout', this._handleFocusOutside);
        }
        const categoryID = this.props.data?.category?.result?.RecordId || 0;
        const locale = this.props.context.request.locale;
        if (categoryID) {
            this._getCategoryDescription(categoryID, locale)
                ?.then(result => {
                    this.setState({
                        categoryDescription: result.Description || ''
                    });
                })
                .catch(error => {
                    console.log('getCategoryDescription API - error', error);
                });
        }

        // if (MsDyn365.isBrowser) {
        //     var main = document.getElementById('main');
        //     if (main) {
        //         main.classList.add('main');
        //     }

        //     var body = document.getElementsByTagName('body')[0];
        //     if (body) {
        //         body.id = 'body';
        //         body.classList.add('body--global-nav');
        //     }

        //     const mainJSURL = `${getAsset('scripts/main.js', this.props.context.request)}`;
        //     const externalScript = document.createElement('script');
        //     externalScript.id = 'external';
        //     externalScript.async = true;
        //     externalScript.type = 'text/javascript';
        //     externalScript.setAttribute('crossorigin', 'anonymous');
        //     externalScript.src = mainJSURL;
        //     document.body.appendChild(externalScript);
        //     console.log('Script executed.');
        // }
    }

    public componentDidUpdate(): void {
        if (this.menuItemRef.current?.children[0] && this.props.isMobileView) {
            (this.menuItemRef.current.children[0] as HTMLElement).focus();
        }
    }

    public componentWillUnmount(): void {
        if (MsDyn365.isBrowser) {
            document.body.removeEventListener('mousedown', this._handleClickOutside, false);
            document.body.removeEventListener('focusout', this._handleFocusOutside, false);
        }
    }

    public render(): JSX.Element | null {
        const {
            isMobileView,
            // MenuList,
            // MobileBackButton,
            // MobileDescriptionContainer,
            // MobileDescriptionLabel,
            Navigation,
            menuItemData,
            resources,
            context,
            data
        } = this.props;

        // Identifying Language
        const toggleLang = context.request.locale.toLowerCase() === MAORI_LANG_CODE ? MAORI_LANG : ENGLISH_LANG;
        let userLang = context.request.user.isAuthenticated && data.customerInformation.result && data.customerInformation.result.Language;
        if (userLang) {
            userLang = userLang.toLowerCase() === MAORI_LANG_CODE ? ENGLISH_LANG : MAORI_LANG;
        }
        const userPrefLang = userLang || toggleLang;
        const preferredLanguage: any = userPrefLang === ENGLISH_LANG && toggleLang === ENGLISH_LANG ? ENGLISH_LANG : MAORI_LANG;

        // Changing language based on preferred language
        const appendLangWord = preferredLanguage === MAORI_LANG ? 'InMaori' : '';
        const KwrHomePageLanguageAttributes: IKwrHomePageLanguageAttributes = {
            languageText: resources[`languageText${appendLangWord}`],
            atuaTabName: resources[`atuaTabName${appendLangWord}`],
            engageTabName: resources[`engageTabName${appendLangWord}`],
            curriculaTabName: resources[`curriculaTabName${appendLangWord}`],
            searchTabName: resources[`searchTabName${appendLangWord}`],
            closeText: resources[`closeText${appendLangWord}`],
            introSearchText1: resources[`introSearchText1${appendLangWord}`],
            introSearchText2: resources[`introSearchText2${appendLangWord}`],
            trySearchText: resources[`trySearchText${appendLangWord}`],
            introAtuaSearchText: resources[`introAtuaSearchText${appendLangWord}`],
            introAtuaBlurbTextRanguini: resources[`introAtuaBlurbTextRanguini${appendLangWord}`],
            introAtuaBlurbTextPapatuanuku: resources[`introAtuaBlurbTextPapatuanuku${appendLangWord}`],
            introAtuaBlurbTextTangaroa: resources[`introAtuaBlurbTextTangaroa${appendLangWord}`],
            introAtuaBlurbTextTane: resources[`introAtuaBlurbTextTane${appendLangWord}`],
            introAtuaBlurbTextTumatauenga: resources[`introAtuaBlurbTextTumatauenga${appendLangWord}`],
            introAtuaBlurbTextRongo: resources[`introAtuaBlurbTextRongo${appendLangWord}`],
            introAtuaBlurbTextHaumia: resources[`introAtuaBlurbTextHaumia${appendLangWord}`],
            introAtuaBlurbTextTawhirimatea: resources[`introAtuaBlurbTextTawhirimatea${appendLangWord}`],
            introAtuaBlurbTextHineahuone: resources[`introAtuaBlurbTextHineahuone${appendLangWord}`],
            introAtuaBlurbTextWhiro: resources[`introAtuaBlurbTextWhiro${appendLangWord}`],
            introAtuaBlurbTextRuaumoko: resources[`introAtuaBlurbTextRuaumoko${appendLangWord}`],
            backButtonText: resources[`backButtonText${appendLangWord}`],
            curatedCollections: resources[`curatedCollections${appendLangWord}`],
            newsEvents: resources[`newsEvents${appendLangWord}`]
        };

        const navArray = menuItemData;
        const atuaIndex = menuItemData?.findIndex(item => item.linkText === 'KAUWHATA ATUA');
        let subMenu: any;
        if (atuaIndex > -1) {
            subMenu = menuItemData[atuaIndex].subMenu ? menuItemData[atuaIndex].subMenu?.slice(1) : null;
        } else {
            subMenu = menuItemData[0].subMenu ? menuItemData[0].subMenu?.slice(1) : null;
        }

        this.currentLevel = 1;
        const mainJSURL = `${getAsset('scripts/main.js', this.props.context.request)}`;
        const codeStr = `
            <div>
            <script type="application/javascript">
        var main = document.getElementById("main");
        if(main){
            main.classList.add("main");
        }

        var body = document.getElementsByTagName("body")[0];
        if(body){
        body.id='body';
        body.classList.add("body--global-nav");
        }
        </script>
        <script type="text/javascript"src=${mainJSURL} defer='defer'></script>
            </div>`;
        const engageSubMenu =
            (this.props.config.cmsNavItems && this.props.config.cmsNavItems.length > 0 && this.props.config.cmsNavItems[0]) || undefined;
        const curriculaSubMenu =
            (this.props.config.cmsNavItems && this.props.config.cmsNavItems.length > 1 && this.props.config.cmsNavItems[1]) || undefined;
        const searchURL = getUrlSync('search', this.props.context.actionContext) || '';
        const { requestUrl } = this.props.context.request.url;
        const langCode = this.props.context.request.locale.toLowerCase();

        let pathUrl = requestUrl.pathname;
        if (langCode === ENGLISH_LANG_CODE) {
            pathUrl = MAORI_TOGGLE_PREFIX + pathUrl;
        } else if (langCode === MAORI_LANG_CODE) {
            pathUrl = pathUrl.replace(ENGLISH_TOGGLE_PREFIX, '');
        }
        const redirectUrl = `${requestUrl.origin}/${pathUrl}${requestUrl.search}`;
        return (
            <Module
                {...Navigation}
                className={classnames(Navigation.className, isMobileView && this.state.activeMenu !== undefined ? 'child' : 'parent')}
            >
                {/* <Node {...MenuList} ref={this.menuNode} tabIndex='-1'>
                    {isMobileView && this.state.activeMenu !== undefined && (
                        <Node {...MobileDescriptionContainer}>
                            <Node {...MobileBackButton} onClick={this._handleGoBack()} />
                            <Node {...MobileDescriptionLabel}>{this.state.mobileViewLabelText}</Node>
                        </Node>
                    )}
                </Node> */}
                {this._renderMobileMenus(searchURL, curriculaSubMenu, subMenu, engageSubMenu, KwrHomePageLanguageAttributes, redirectUrl)}
                {this._renderNavigation(navArray, searchURL, KwrHomePageLanguageAttributes, redirectUrl)}
                <ul className={`mega-dropdowns ${this.state.isMenuOpen ? 'show' : 'hidden'}`}>
                    <CategoryModal
                        index={0}
                        menuName={'Kauwhata'}
                        subMenuItems={subMenu}
                        renderButton={() => {
                            <button tabIndex={1} id='atuaToggle' className='header-menu__mega-nav-toggler'>
                                <span>{navArray[0].linkText}</span>
                            </button>;
                        }}
                        buttonClassname={'header-menu__mega-nav-toggler'}
                        context={this.props.context}
                        id={'1'}
                        typeName={'2'}
                        data={[]}
                        isModalOpen={this.state.categoryMemuIsActive}
                        btnCloseClick={() => this.handleSubmenuModal()}
                        KwrHomePageLanguageAttributes={KwrHomePageLanguageAttributes}
                        preferredLanguage={preferredLanguage}
                    ></CategoryModal>
                    {engageSubMenu && (
                        <EnagageModal
                            index={0}
                            menuName={'Engage'}
                            subMenuItems={engageSubMenu}
                            renderButton={() => {
                                <button tabIndex={1} id='atuaToggle' className='header-menu__mega-nav-toggler'>
                                    <span>{navArray[0].linkText}</span>
                                </button>;
                            }}
                            buttonClassname={'header-menu__mega-nav-toggler'}
                            context={this.props.context}
                            id={'1'}
                            typeName={'2'}
                            data={[]}
                            isModalOpen={this.state.engageMenuIsActive}
                            btnCloseClick={() => this.setEngageMenuIsActive()}
                            KwrHomePageLanguageAttributes={KwrHomePageLanguageAttributes}
                            preferredLanguage={preferredLanguage}
                        ></EnagageModal>
                    )}
                    {curriculaSubMenu && (
                        <CurriculaModal
                            index={0}
                            menuName={'Engage'}
                            subMenuItems={curriculaSubMenu}
                            renderButton={() => {
                                <button tabIndex={1} id='atuaToggle' className='header-menu__mega-nav-toggler'>
                                    <span>{navArray[0].linkText}</span>
                                </button>;
                            }}
                            context={this.props.context}
                            id={'1'}
                            typeName={'2'}
                            data={[]}
                            isModalOpen={this.state.curriculaMenuIsActive}
                            btnCloseClick={() => this.setCurriculaMenuIsActive()}
                            KwrHomePageLanguageAttributes={KwrHomePageLanguageAttributes}
                            preferredLanguage={preferredLanguage}
                        ></CurriculaModal>
                    )}
                </ul>
                <div dangerouslySetInnerHTML={{ __html: codeStr }} />
            </Module>
        );
    }

    private handleSubmenuModal() {
        this.setState({
            categoryMemuIsActive: !this.state.categoryMemuIsActive,
            isMenuOpen: !this.state.isMenuOpen
        });
    }

    private setCurriculaMenuIsActive() {
        this.setState({
            curriculaMenuIsActive: !this.state.curriculaMenuIsActive,
            isMenuOpen: !this.state.isMenuOpen
        });
    }

    private setEngageMenuIsActive() {
        this.setState({
            engageMenuIsActive: !this.state.engageMenuIsActive,
            isMenuOpen: !this.state.isMenuOpen
        });
    }

    private _renderSubMenu(subMenus?: IMenuItemData[], activeMenu?: number, IsSubMenu?: boolean): JSX.Element | null {
        const { isMobileView, ListItem } = this.props;
        const enableMultiSupportMenu = this.props.config.enableMultilevelMenu || false;
        const multiLevelSupportedMenu = this.props.config.menuLevelSupport || 3;

        // Const isParentMenu:boolean= false;
        if (activeMenu && this.state.activeMenu !== activeMenu) {
            this.props.context.telemetry.error('Navigation Active menu content is empty, module wont render.');
            return null;
        }

        if (!subMenus || subMenus.length === 0) {
            this.props.context.telemetry.error('Navigation Submenu content is empty, module wont render.');
            return null;
        }

        let levelClassName: string = '';
        const menuOptions =
            subMenus &&
            subMenus.map((option: IMenuItemData, idx: number) => {
                const hasOptions = option.subMenu && option.subMenu.length > 0;
                let menuItem: JSX.Element | null;
                if (hasOptions && isMobileView) {
                    menuItem = this._renderButtonMenuItem(option, activeMenu, idx);
                } else {
                    menuItem = option.linkURL ? this._renderLinkMenuItem(option, idx) : this._renderSpanMenuItem(option);
                }

                let subMenu;
                const haveSubmenu = hasOptions && enableMultiSupportMenu && this.currentLevel <= Math.round(multiLevelSupportedMenu) - 1;
                if (haveSubmenu) {
                    this.currentLevel++;
                    levelClassName = enableMultiSupportMenu ? `level-${this.currentLevel.toString()}` : '';
                    subMenu = this._renderSubMenu(option.subMenu, isMobileView ? option.id : undefined, true);
                }
                return (
                    <Node
                        {...ListItem}
                        key={option.id}
                        className={classnames(ListItem.className, haveSubmenu && 'havesubmenu')}
                        ref={this._shouldAddFocusMenuRef(idx, this.state.mobileViewLabelText, option.linkText) ? this.menuItemRef : null}
                    >
                        {menuItem}
                        {subMenu}
                    </Node>
                );
            });
        return this._renderMenu(levelClassName, menuOptions, activeMenu, IsSubMenu);
    }

    private _renderButtonMenuItem(option: IMenuItemData, activeMenu?: number, index?: number): JSX.Element | null {
        const { Button } = this.props;
        return (
            <Node
                key={index}
                {...Button}
                onClick={this._handleDropdownToggle(option, activeMenu)}
                onFocus={this._closeSubmenu}
                aria-haspopup={!(this.state.activeMenu && this.state.activeMenu === option.id)}
                aria-expanded={!!(this.state.activeMenu && this.state.activeMenu === option.id)}
                data-parent={activeMenu}
            >
                {option.linkText}
            </Node>
        );
    }

    private _getCategoryDescription(categroyID: number, locale: string) {
        try {
            const context: any = { callerContext: this.props.context.actionContext };
            return getCategoryDescriptionAsync(context, categroyID, locale).then((result: any) => {
                return result;
            });
        } catch (err) {
            console.log(err);
            return;
        }
    }

    private _renderLinkMenuItem(
        option: IMenuItemData,
        index?: number,
        hoverEffect: boolean = true,
        isParent: boolean = false
    ): JSX.Element | null {
        const { Link } = this.props;
        const linkText = option.linkText ? option.linkText : '';
        const imagesource = option.imageSource ? option.imageSource : '';
        this.payLoad.contentAction.etext = linkText;
        const attributes = getTelemetryAttributes(this.telemetryContent, this.payLoad);
        return (
            <Node
                {...Link}
                key={index}
                onFocus={isParent && this._closeSubmenu}
                target={option.shouldOpenNewTab ? '_blank' : undefined}
                onMouseOver={hoverEffect && this._updateCategoryImage(imagesource, option)}
                href={option.linkURL}
                {...attributes}
                onClick={onTelemetryClick(this.telemetryContent, this.payLoad, linkText)}
            >
                {option.linkText}
            </Node>
        );
    }

    private _renderPromotionalLink(linkText?: string, linkUrl?: string): JSX.Element | null {
        const { Link } = this.props;
        this.payLoad.contentAction.etext = linkText;
        const attributes = getTelemetryAttributes(this.telemetryContent, this.payLoad);
        if (linkText && linkUrl) {
            return (
                <Node {...Link} href={linkUrl} {...attributes} onClick={onTelemetryClick(this.telemetryContent, this.payLoad, linkText)}>
                    {linkText}
                </Node>
            );
        }
        return null;
    }

    private _renderSpanMenuItem(option: IMenuItemData, index?: number, isParent: boolean = false): JSX.Element | null {
        const { Span } = this.props;
        return (
            <Node key={index} {...Span} onFocus={isParent && this._closeSubmenu}>
                {option.linkText}
            </Node>
        );
    }

    private _renderMenu(level: string, menuOptions: JSX.Element[], currentItem?: number, submenu?: boolean): JSX.Element | null {
        const { DivContainer, MenuList, ImageDivContainer, showCategoryImage, showPromotionalContent, isMobileView } = this.props;
        const categoryImageDisplay =
            !isMobileView &&
            (showCategoryImage || showPromotionalContent) &&
            !ArrayExtensions.hasElements(this.state.categoryImage) &&
            !submenu;
        const promotionalContentDisplay =
            !isMobileView && showPromotionalContent && ArrayExtensions.hasElements(this.state.categoryImage) && !submenu;
        const DivContainerClass = this.currentLevel > 2 || categoryImageDisplay ? DivContainer!.className : 'ms-nav__deafult';
        this.currentLevel = 1;
        return (
            <Node {...DivContainer} className={DivContainerClass}>
                <Node
                    {...MenuList}
                    className={classnames(
                        MenuList.className,
                        level,
                        categoryImageDisplay && 'havecateImage',
                        categoryImageDisplay &&
                            this.props.config.menuLevelSupport &&
                            this.props.config.menuLevelSupport > 2 &&
                            'navmenu-multi-level'
                    )}
                >
                    {menuOptions}
                </Node>
                {categoryImageDisplay &&
                    this.state.categoryImage &&
                    this.state.categoryImage.map(item => (
                        <Node {...ImageDivContainer} className={ImageDivContainer!.className}>
                            {this.state.categoryImage && this._getCategoryImage(item)}
                            {promotionalContentDisplay && this._renderPromotionalLink(item.altText, item.additionalProperties?.linkUrl)}
                        </Node>
                    ))}
            </Node>
        );
    }

    private readonly _updateCategoryImage = (categoryImageSrc: string, option: IMenuItemData) => () => {
        const linkText = option && option.linkText ? option.linkText : '';
        const promotionalImage: IImageData[] = [{ src: categoryImageSrc, altText: linkText }];

        // Read category and promotional image in one array
        if (ArrayExtensions.hasElements(option.promotionalContent)) {
            option.promotionalContent.map(item => {
                if (item && item.image) {
                    const imageSrc = item.image.src;
                    const promotionalItemImageSettings = item.image.imageSettings;
                    promotionalImage.push({
                        src: imageSrc,
                        altText: item.text,
                        imageSettings: promotionalItemImageSettings,
                        additionalProperties: { linkUrl: item.linkUrl.destinationUrl }
                    });
                }
            });
        }
        this.setState({
            categoryImage: promotionalImage.length > 0 ? promotionalImage : [{ src: 'empty' }],
            categoryImageAltText: linkText
        });
    };

    private readonly _handleDropdownToggle = (data: IMenuItemData, parentId?: number) => () => {
        if (!this.props.isMobileView) {
            this.setState({
                activeMenu: this.state.activeMenu && this.state.activeMenu === data.id! ? undefined : data.id!,
                parentMenu: parentId
            });
            if (this.props.showCategoryImage) {
                this._updateCategoryImage(data.imageSource!, data)();
            }
        } else {
            NavigationMenuView.isBackTrack = false;
            this.setState({
                activeMenu: data.id,
                mobileViewLabelText: data.linkText!,
                parentMenu: parentId
            });
        }
    };

    // private readonly _handleGoBack = () => () => {
    //     NavigationMenuView.isBackTrack = true;
    //     this.setState({ activeMenu: this.state.parentMenu });
    // };

    /**
     * Method to handle click outside of menu.
     * @param event -HTML event.
     */
    private readonly _handleClickOutside = (event: MouseEvent) => {
        if (this.menuNode.current && !this.menuNode.current.contains(event.target as Node)) {
            this.setState({
                activeMenu: undefined,
                mobileViewLabelText: '',
                categoryImage: null
            });
        }
    };

    /**
     * Method to handle click outside of menu.
     * @param event -HTML event.
     */
    private readonly _handleFocusOutside = (event: FocusEvent) => {
        if (this.menuNode.current && !this.menuNode.current.contains(event.relatedTarget as Node)) {
            this._closeSubmenu();
        }
    };

    /**
     * Checks to assign a ref for focus.
     * @param index -Sub menu list index.
     * @param mobileViewLabelText -Parent user clicked Sub menu list.
     * @param optionLinkText -Sub menu list.
     * @returns Ref.
     */
    private readonly _shouldAddFocusMenuRef = (index: number, mobileViewLabelText?: string, optionLinkText?: string) => {
        if (!NavigationMenuView.isBackTrack && index === 0) {
            return true;
        }
        if (!optionLinkText || !mobileViewLabelText) {
            return false;
        }
        return mobileViewLabelText === optionLinkText;
    };

    private _closeSubmenu(): void {
        if (!this.props.isMobileView) {
            this.setState({ activeMenu: undefined, categoryImage: null, mobileViewLabelText: '' });
        }
    }

    private readonly _getCategoryImage = (categoryImage?: IImageData): React.ReactNode | null => {
        if (!categoryImage || !categoryImage.src) {
            return null;
        }

        const categoryImageUrl = generateImageUrl(`${categoryImage.src}`, this.props.context.actionContext.requestContext.apiSettings);
        const defaultImageSettings: IImageSettings = {
            viewports: {
                xs: { q: 'w=300&h=250&m=8', w: 0, h: 0 },
                sm: { q: 'w=300&h=250&m=8', w: 0, h: 0 },
                md: { q: 'w=300&h=250&m=8', w: 0, h: 0 },
                lg: { q: 'w=300&h=250&m=8', w: 0, h: 0 }
            },
            lazyload: true
        };
        if (categoryImageUrl !== undefined) {
            return (
                <Image
                    requestContext={this.props.context.actionContext.requestContext}
                    className='ms-nav-image__item'
                    {...categoryImage}
                    gridSettings={this.props.context.request.gridSettings!}
                    imageSettings={categoryImage.imageSettings ?? this.props.config.categoryImageSettings ?? defaultImageSettings}
                    loadFailureBehavior='hide'
                    role='tabpanel'
                    id='categoryImageTag__categoryImage'
                    altText={categoryImage.altText}
                />
            );
        }
        return null;
    };

    private _getSlot(slotName: string): React.ReactNode[] | null {
        const { slots } = this.props;
        return (slots && slots[slotName] && slots[slotName].length && slots[slotName]) || null;
    }

    private _getCuratedCollectionData(): void {
        const actionContext: any = this.props.context?.actionContext;
        const channelId = this.props.context?.request?.apiSettings?.channelId;
        const catalogID = this.props.context?.request?.apiSettings?.catalogId;
        const productIDs = [];

        if (this.props.context?.request?.url?.requestUrl?.pathname.includes('/curatedcollection')) {
            const recordId: string =
                this.props.context.request.query && this.props.context.request.query.rid ? this.props.context.request.query.rid : '';

            productIDs.push(parseInt(recordId, 10));

            if (productIDs.length > 0) {
                const searchCriteriaInput: ProductSearchCriteria = {
                    Context: { CatalogId: catalogID, ChannelId: channelId },
                    Ids: productIDs
                };

                void searchByCriteriaAsync(actionContext, searchCriteriaInput).then(products => {
                    if (products.length > 0) {
                        const newImageUrl = generateImageUrl(products[0].PrimaryImageUrl, this.props.context.request.apiSettings);
                        this.setState({ ...this.state, curatedProduct: [{ ...products[0], PrimaryImageUrl: newImageUrl }] });
                    }
                });
            }
        }
    }

    // private _getSiteRedirectionUrl() {
    //     const { requestUrl } = this.props.context.request.url;
    //     const langCode = this.props.context.request.locale.toLowerCase();

    //     let pathUrl = requestUrl.pathname;
    //     if (langCode === ENGLISH_LANG_CODE) {
    //         pathUrl = `${MAORI_TOGGLE_PREFIX} + ${pathUrl}`;
    //     } else if (langCode === MAORI_LANG_CODE) {
    //         pathUrl = pathUrl.replace(ENGLISH_TOGGLE_PREFIX, '');
    //     }
    //     const redirectUrl = `${requestUrl.origin}/${pathUrl}${requestUrl.search}`;
    //     return redirectUrl;
    // }

    private _renderNavigation(
        menuItemData: IMenuItemData[],
        searchURL: string,
        KwrHomePageLanguageAttributes: IKwrHomePageLanguageAttributes,
        redirectUrl: string
    ): JSX.Element | null {
        // const { siteOptions } = this.props.config;
        const breadcrumbSlot = this._getSlot('breadcrumb');
        const logourl = `${getAsset('images/logo-kauwhata-reo.svg', this.props.context.request)}`;
        // const { logoLink, logoImage } = this.props.config;
        const homeURL = getUrlSync('home', this.props.context.actionContext) || '';
        const currentCategory = this.props.data?.category?.result;
        const toggleLang = this.props.context.request.locale.toLowerCase() === MAORI_LANG_CODE ? MAORI_LANG : ENGLISH_LANG;
        const toggleTooltip = toggleLang === 'maori' ? 'Whakaatuhia te paetukutuku i te reo Ingarihi' : 'Display website in Te Reo Māori';
        // const siteOptionsUrl =
        //     (siteOptions && siteOptions[0] && siteOptions[0]?.siteRedirectUrl && siteOptions[0]?.siteRedirectUrl?.destinationUrl) || '';
        // const locale = this.props.context.request.locale;
        // console.log('locale:', locale);
        void this._getCuratedCollectionData();

        return (
            <>
                <header id='header' className='header'>
                    <div className='header__backdrop-hills'></div>
                    <div className='header__explore-by'>
                        <ul className='header-menu no-print'>
                            {menuItemData?.map((categoryItem, index: number) => {
                                return this._renderHeaderMenuItem(categoryItem, index, KwrHomePageLanguageAttributes);
                            })}
                            <li className='header-menu__item header-menu__item--whata-patoro header__atua' id='whata-patoro__mega'>
                                <button
                                    tabIndex={2}
                                    id='newsEventsToggle'
                                    className='header-menu__mega-nav-toggler'
                                    onClick={() => {
                                        this.setEngageMenuIsActive();
                                    }}
                                >
                                    <span>{KwrHomePageLanguageAttributes.engageTabName}</span>
                                </button>
                            </li>
                            <li className='header-menu__item header-menu__item--learning-areas header__atua' id='learning-areas__mega'>
                                <button
                                    tabIndex={3}
                                    id='learningAreasToggle'
                                    className='header-menu__mega-nav-toggler'
                                    onClick={() => {
                                        this.setCurriculaMenuIsActive();
                                    }}
                                >
                                    <span>{KwrHomePageLanguageAttributes.curriculaTabName}</span>
                                </button>
                            </li>
                            <li className='header-menu__item header-menu__item--search'>
                                <a tabIndex={4} href={searchURL} title='Search'>
                                    <span>
                                        <span className='icon--small icon--search-light'></span>
                                        {KwrHomePageLanguageAttributes.searchTabName}
                                    </span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div className='header__container'>
                        <div className='header__inner'>
                            <div className='header__panel1'>
                                <div className='header__logo'>
                                    {/* <Logo
                                    {...{
                                        link: logoLink,
                                        image: logoImage,
                                        className: 'ms-header__logo',
                                        gridSettings: this.props.context.request.gridSettings,
                                        requestContext: this.props.context.request,
                                        telemetryContent: this.telemetryContent,
                                        typeName: this.props.typeName
                                    }}
                                /> */}
                                    <a title='Go to Home page' className='title__link' href={homeURL}>
                                        <img className='header__title__logo' src={logourl} alt='Matauranga Logo' />
                                    </a>
                                </div>
                                <div className='header__crumbs'>{breadcrumbSlot}</div>
                                <div className='header__title-block'>
                                    <div className='header__details'>
                                        <div className='header__title'>
                                            <div>
                                                {currentCategory?.Name}{' '}
                                                {this.props.context?.request?.url?.requestUrl?.pathname.includes('/search') && (
                                                    <h1 className='header__title--searchtext'>
                                                        <br /> {KwrHomePageLanguageAttributes.searchTabName}
                                                    </h1>
                                                )}
                                                {this.props.context?.request?.url?.requestUrl?.pathname.includes('/curatedcollection') && (
                                                    <>
                                                        <a className='header__title--curatedtext' href={searchURL}>
                                                            {KwrHomePageLanguageAttributes.curatedCollections}
                                                        </a>

                                                        <span className='header__title--curatedproduct'>
                                                            /{this.state.curatedProduct[0] && this.state.curatedProduct[0].Name}
                                                        </span>
                                                        {this.state.curatedProduct[0] && this.state.curatedProduct[0].PrimaryImageUrl && (
                                                            <img
                                                                src={
                                                                    this.state.curatedProduct[0] &&
                                                                    this.state.curatedProduct[0].PrimaryImageUrl
                                                                }
                                                                alt={this.state.curatedProduct[0] && this.state.curatedProduct[0].Name}
                                                            />
                                                        )}
                                                        <h1 className='header__title--curatedproductheading'>
                                                            {this.state.curatedProduct[0] && this.state.curatedProduct[0].Name}
                                                        </h1>
                                                    </>
                                                )}
                                                {this.props.context?.request?.url?.requestUrl?.pathname.includes('/newsandevents') && (
                                                    <>
                                                        {/* <p>Explore News & Events</p> */}
                                                        <h1 className='header__title--newsandevents'>
                                                            {KwrHomePageLanguageAttributes.newsEvents}
                                                        </h1>
                                                    </>
                                                )}
                                            </div>
                                        </div>

                                        <div className='header__description'>{this.state.categoryDescription}</div>
                                    </div>
                                </div>
                            </div>
                            <div className='header__panel2'>
                                <div className='moe-language-toggle-holder--desktop'>
                                    <a
                                        href={redirectUrl}
                                        role='button'
                                        className='js-i18n-toggle moe-btn-language-toggle'
                                        title={toggleTooltip}
                                    >
                                        <ul className='moe-btn-language-toggle__list'>
                                            <li
                                                className={`moe-btn-language-toggle__list-item ${
                                                    toggleLang === 'maori' ? 'active' : 'inactive'
                                                }`}
                                            >
                                                <span>Reo Māori</span>
                                            </li>
                                            <li
                                                className={`moe-btn-language-toggle__list-item ${
                                                    toggleLang === 'maori' ? 'inactive' : 'active'
                                                }`}
                                            >
                                                <span>English</span>
                                            </li>
                                        </ul>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
            </>
        );
    }

    private _renderHeaderMenuItem(
        menuItemData: IMenuItemData,
        itemIndex: number,
        KwrHomePageLanguageAttributes: IKwrHomePageLanguageAttributes
    ): JSX.Element | null {
        if (itemIndex === 0) {
            return (
                <li className='header-menu__item header-menu__item--atua header__atua current' id='atua__mega'>
                    <button
                        tabIndex={1}
                        id='atuaToggle'
                        className='header-menu__mega-nav-toggler'
                        onClick={() => {
                            this.handleSubmenuModal();
                        }}
                    >
                        {/* <span>{menuItemData.linkText}</span> */}
                        <span>{KwrHomePageLanguageAttributes.atuaTabName}</span>
                    </button>
                </li>
            );
        } else {
            return <></>;
        }
    }

    private _renderMobileMenus(
        searchURL: string,
        curriculaSubMenu: any,
        subMenu: any,
        engageSubMenu: any,
        KwrHomePageLanguageAttributes: IKwrHomePageLanguageAttributes,
        redirectUrl: string
    ) {
        // const { siteOptions } = this.props.config;
        const toggleLang = this.props.context.request.locale.toLowerCase() === MAORI_LANG_CODE ? MAORI_LANG : ENGLISH_LANG;
        const toggleTooltip = toggleLang === 'maori' ? 'Whakaatuhia te paetukutuku i te reo Ingarihi' : 'Display website in Te Reo Māori';
        // const siteOptionsUrl =
        //     (siteOptions && siteOptions[0] && siteOptions[0]?.siteRedirectUrl && siteOptions[0]?.siteRedirectUrl?.destinationUrl) || '';

        return (
            <>
                <div className='overlay' id='overlay'>
                    <nav className='overlay-menu'>
                        <nav className='headerMenuMobile no-print'>
                            <a href={redirectUrl} role='button' className='js-i18n-toggle moe-btn-language-toggle' title={toggleTooltip}>
                                <ul className='moe-btn-language-toggle__list'>
                                    <li className={`moe-btn-language-toggle__list-item ${toggleLang === 'maori' ? 'active' : 'inactive'}`}>
                                        <span>Reo Māori</span>
                                    </li>
                                    <li className={`moe-btn-language-toggle__list-item ${toggleLang === 'maori' ? 'inactive' : 'active'}`}>
                                        <span>English</span>
                                    </li>
                                </ul>
                            </a>

                            <ul className='headerMenuMobile__list'>
                                <li className='headerMenuMobile__list-item'>
                                    <a href={searchURL} title='Search' className='headerMenuMobile__list-link'>
                                        {KwrHomePageLanguageAttributes.searchTabName}
                                        <i className='icon--medium icon--search-white'></i>
                                    </a>
                                </li>
                                <li className='headerMenuMobile__list-item'>
                                    <a className='headerMenuMobile__list-link' href='#' data-target='mobile-child-atua'>
                                        {KwrHomePageLanguageAttributes.atuaTabName}
                                        <i className='icon--small icon--chevron-right-red'></i>
                                    </a>
                                </li>
                                <li className='headerMenuMobile__list-item'>
                                    <a className='headerMenuMobile__list-link' href='#' data-target='mobile-child-engagement'>
                                        {KwrHomePageLanguageAttributes.engageTabName}
                                        <i className='icon--small icon--chevron-right-red'></i>
                                    </a>
                                </li>
                                <li className='headerMenuMobile__list-item'>
                                    <a className='headerMenuMobile__list-link' href='#' data-target='mobile-child-curricula'>
                                        {KwrHomePageLanguageAttributes.curriculaTabName}
                                        <i className='icon--small icon--chevron-right-red'></i>
                                    </a>
                                </li>
                            </ul>

                            <a href='#' className='headerMenuMobile__back-link' id='mobileMenuClose'>
                                <i className='icon--small icon--chevron-left-red'></i> {KwrHomePageLanguageAttributes.backButtonText}
                            </a>
                            <ul className='headerMenuMobile__list headerMenuMobile__list--child' id='mobile-child-curricula'>
                                <div className='headerMenuMobile__child-main-title'>
                                    <i className='icon icon--whata-mobile-menu'></i> {KwrHomePageLanguageAttributes.curriculaTabName}
                                </div>
                                {curriculaSubMenu &&
                                    curriculaSubMenu.subMenus &&
                                    curriculaSubMenu.subMenus.length > 0 &&
                                    curriculaSubMenu.subMenus?.map((categoryItem: any) => {
                                        return renderMoblieCurriculaMenuItem(categoryItem);
                                    })}
                            </ul>

                            <ul className='headerMenuMobile__list headerMenuMobile__list--child' id='mobile-child-atua'>
                                <div className='headerMenuMobile__child-main-title headerMenuMobile__child-main-title--atua'>
                                    <i className='icon icon--whata-mobile-menu'></i> {KwrHomePageLanguageAttributes.atuaTabName}
                                </div>

                                {subMenu &&
                                    subMenu.length > 0 &&
                                    subMenu?.map((categoryItem: any) => {
                                        return renderMobileMenuItem(categoryItem, this.props);
                                    })}
                            </ul>
                            <ul className='headerMenuMobile__list headerMenuMobile__list--child' id='mobile-child-engagement'>
                                <div className='headerMenuMobile__child-main-title'>
                                    <i className='icon icon--whata-mobile-menu'></i> {KwrHomePageLanguageAttributes.engageTabName}
                                </div>
                                {engageSubMenu &&
                                    engageSubMenu.subMenus &&
                                    engageSubMenu.subMenus.length > 0 &&
                                    engageSubMenu.subMenus?.map((categoryItem: any) => {
                                        return renderMoblieEngageMenuItem(categoryItem);
                                    })}
                            </ul>
                        </nav>
                    </nav>
                </div>
                <div className='button_container' id='toggle' role='button' aria-pressed='false'>
                    <div className='close-text'>{KwrHomePageLanguageAttributes.closeText}</div>
                    <span className='top'></span>
                    <span className='middle'></span>
                    <span className='bottom'></span>
                </div>
            </>
        );

        function renderMobileMenuItem(categoryItem: any, props: INavigationMenuViewProps) {
            const categoryImageUrl = generateImageUrl(
                `${categoryItem.imageSource}`,
                props.context.actionContext.requestContext.apiSettings
            );
            return (
                <>
                    <li className='headerMenuMobile__child-item'>
                        <a
                            href={categoryItem.linkURL}
                            className='headerMenuMobile__child-link headerMenuMobile__child-link--atua'
                            title={categoryItem.linkText}
                        >
                            <span className='headerMenuMobile__atua-image-wrapper'>
                                <img
                                    src={categoryImageUrl}
                                    alt={categoryItem.linkText}
                                    //title={categoryItem.linkText}
                                    className='headerMenuMobile__atua-image'
                                ></img>{' '}
                            </span>
                            <span className='headerMenuMobile__atua-title'> {categoryItem.linkText}</span>
                        </a>
                    </li>
                </>
            );
        }

        function renderMoblieCurriculaMenuItem(menuItem: any) {
            return (
                <>
                    <div className='headerMenuMobile__child-sub-heading'>{menuItem.linkText}</div>

                    {renderMobileCurriculaSubMenuItems(menuItem)}
                </>
            );
        }

        function renderMobileCurriculaSubMenuItems(subMenuItem: any) {
            return (
                <>
                    {subMenuItem &&
                        subMenuItem.subMenus &&
                        subMenuItem.subMenus.length > 0 &&
                        subMenuItem.subMenus?.map((subMenu: any, idx: number) => {
                            return (
                                <>
                                    <li className='headerMenuMobile__child-item'>
                                        <a href={subMenu?.linkUrl?.destinationUrl} className='headerMenuMobile__child-link'>
                                            {subMenu.linkText}
                                            <i className='icon--small icon--external-link-grey'></i>
                                        </a>
                                    </li>
                                </>
                            );
                        })}
                </>
            );
        }

        function renderMoblieEngageMenuItem(menuItem: any) {
            return (
                <>
                    <div className='headerMenuMobile__child-sub-heading'>{menuItem.linkText}</div>
                    {renderMobileEngageSubMenuItems(menuItem)}
                </>
            );
        }

        function renderMobileEngageSubMenuItems(subMenuItem: any) {
            return (
                <>
                    {subMenuItem &&
                        subMenuItem.subMenus &&
                        subMenuItem.subMenus.length > 0 &&
                        subMenuItem.subMenus?.map((subMenu: any, idx: number) => {
                            return (
                                <>
                                    <li className='headerMenuMobile__child-item' key={idx}>
                                        <a className='headerMenuMobile__child-link' href={subMenu?.linkUrl?.destinationUrl}>
                                            {subMenu.linkText}
                                        </a>
                                    </li>
                                </>
                            );
                        })}
                </>
            );
        }
    }

    // private _handleLangToggle = (langCode: string) => {
    //     const { requestUrl } = this.props.context.request.url;
    //     const siteOptions = this.props.config.siteOptions && this.props.config.siteOptions;

    //     if (siteOptions.length > 0) {
    //         siteOptions.map((item, index) => {
    //             if (index === 0) {
    //                 window.location.href = item?.siteRedirectUrl?.destinationUrl;
    //             }
    //             return;
    //         });
    //     } else {
    //         let pathUrl;
    //         if (langCode === 'en-NZ') {
    //             pathUrl = '';
    //         } else if (langCode === 'mi-NZ') {
    //             pathUrl = 'mi-NZ/';
    //         }
    //         const redirectUrl = `${requestUrl.origin}/${pathUrl}${requestUrl.search}`;
    //         window.location.href = redirectUrl;
    //     }
    // };
}

export default NavigationMenuView;
